








import { defineComponent } from '@vue/composition-api';

import PrivateChat from '@/components/Question/PrivateChat.vue';
// import usePusher from '@/usePusher';

const Chat = defineComponent({
  components: {
    PrivateChat,
  },
  // setup() {},
});

export default Chat;
